import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CheckBoxCustomHelper from '../../../helpers/CheckBoxCustomHelper';
import {
    renderFirstNameField,
    renderSecondLastNameField,
    renderLastNameField,
    renderEmailField,
    renderMobilePhoneField,
    renderDateOfBirthField,
    renderGenericCheckboxGroup,
    renderWeightField,
    renderGenericTextField,
    renderOptionsField
} from '../../../helpers/form/fields'
import {reduxForm, getFormValues, Field} from 'redux-form';
import { account_update_volontario } from '../../../redux/actions/accountActions';

import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
import {CheckboxGroup, renderTextField} from "../../../helpers/form/renders";
import {common_alertOpen} from "../../../redux/actions/commonActions";
const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
};

const styles1 = theme => ({
    success: {
        backgroundColor: green[600]
    },
    error: {
        backgroundColor: theme.palette.error.dark
    },
    info: {
        backgroundColor: theme.palette.primary.dark
    },
    warning: {
        backgroundColor: amber[700]
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit
    },
    message: {
        display: "flex",
        alignItems: "center"
    }
});

function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={onClose}
                >
                    <CloseIcon className={classes.icon} />
                </IconButton>
            ]}
            {...other}
        />
    );
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
class VolontarioForm extends Component {

    state = {
        store: null
    };

    componentDidMount() {
        this.initializeForm();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.account.data !== prevProps.account.data) {
            this.initializeForm(this.props.account.data)
        }
    }
    openNotification = (values) => {
        values && this.setState({ open: true });

    }
    handleSubmit = (values) => {
        console.log(this.props)
        this.props.dispatch(
            account_update_volontario(values, this.props.account.data.user.id, this.props.auth.token, () => this.props.dispatch(
                common_alertOpen(
                    "Guardado!",
                    "success"
                )
            ))
        );
        // this.setState({ open: true });
    }

    initializeForm(user) {
        if (!user) {
            user = this.props.account.data;
        }
        console.log("user", user);
        const initialFormState = {
            weight: user.weight,
            has_tattoos: user.has_tattoos === false ? "1" : "2",
            has_tattoos_value: user.has_tattoos_value || undefined,
            health_and_care_products: user.health_and_care_products,
            consumer_usual_products_other: user.consumer_usual_products_other,
            use_hair_removal_products: user.use_hair_removal_products === false ? "1" : "2",
            hair_removal_zones: user.hair_removal_zones,
            hair_removal_products_list: user.hair_removal_products_list,
            had_laser_hair_removal: user.had_laser_hair_removal === false ? "1" : "2",
            had_laser_hair_removal_user_input: user.had_laser_hair_removal_user_input,
            wear_glasses: user.wear_glasses === false ? "1" : "2",
            wear_contact_lenses: user.wear_contact_lenses === false ? "1" : "2",
            had_surgery: user.had_surgery === false ? "1" : "2",
            had_surgery_description:user.had_surgery_description,
            had_recent_surgery_value: user.had_recent_surgery_value,
            enrolled_in_other_center: user.enrolled_in_other_center === false ? "1" : "2",
            consumer_usual_products:user.consumer_usual_products,
            id: user.id,
            health_and_care_products_answer: user.health_and_care_products_answer,
            // test_type: user.test_type,
            // test_application_zone: user.test_application_zone,
            // work_status: user.work_status && user.work_status.toString(),
            // how_you_know_about_cosmocare: user.how_you_know_about_cosmocare,
            // using_social_networks: user.using_social_networks,
            // social_networks: user.social_networks,
            // social_networks_other: user.social_networks_other,
            // social_security_affiliation: user.social_security_affiliation === "false" ? "1" : "2",
            // why_participate_in_tests: user.why_participate_in_tests
        };
        this.props.initialize(initialFormState);
    }


    render() {
        const { account, common, formValues, pristine, submitting, handleSubmit } = this.props;
        if (!formValues) {
            return <div></div>
        }
        let accData = account.data;
        console.log(accData);
        return (
            <React.Fragment >
                <form onSubmit={handleSubmit(this.handleSubmit.bind(this))} autocomplete="off">
                    <Grid container spacing={8} alignItems="flex-end">


                        {/* <Grid item xs={12}>
                            {renderFirstNameField("First name")}
                        </Grid>
                        <Grid item xs={12}>
                            {renderLastNameField("Last name")}
                        </Grid>
                        <Grid item xs={12}>
                            {renderSecondLastNameField("Second Last name")}
                        </Grid>
                        <Grid item xs={12}>
                            {renderDateOfBirthField("Fecha de nacimiento")}
                        </Grid> */}
                        {/* <Grid item xs={12}>
                            {renderEmailField("Email")}
                        </Grid> */}
                        {/* <Grid item xs={12}>
                            {renderMobilePhoneField("Tel. Móvil:")}
                        </Grid> */}
                        <Grid item xs={12}>
                            {renderWeightField('Peso (kg)', 'weight')}
                        </Grid>
                        
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Estás apuntado/a a otro centro de pruebas cosméticas?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'enrolled_in_other_center',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                            ¿Le han realizado alguna intervención quirúrgica recientemente o en el último año?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'had_surgery',
                                options: this.props.common.yesno || [],
                            })}
                            {
                                formValues.had_surgery == "2" && renderGenericTextField('¿De qué tipo y cuándo?', 'had_surgery_description')
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Utiliza alguno de los siguientes productos?
                            </Typography>
                        </Grid>
                        {/*<Grid item xs={12}>*/}
                        {/*    {renderGenericCheckboxGroup({*/}
                        {/*        name: 'health_and_care_products',*/}
                        {/*        options: this.props.common.health_and_care_products || [],*/}
                        {/*        fullWidth: true*/}
                        {/*    })}*/}
                        {/*    {*/}
                        {/*        formValues.health_and_care_products &&*/}
                        {/*        formValues.health_and_care_products.map((value) => (value === 46 && renderGenericTextField('Especifique cuál', 'consumer_usual_products_other')))*/}
                        {/*    }*/}
                        {/*</Grid>*/}
                        <Grid item xs={12}>
                            <Field
                                name="health_and_care_products"
                                component={CheckboxGroup}
                                options={this.props.common.health_and_care_products || []}
                                enableRadioGroupAnswer
                                enabledRadioGroupLabels={[
                                    { 'id': 1, 'value': 'Ocasionalmente', 'label': 'Ocasionalmente' },
                                    { 'id': 2, 'value': 'Habitualmente', 'label': 'Habitualmente' }
                                ]}
                            />
                            {formValues.health_and_care_products_value && formValues.health_and_care_products_value.indexOf(46) > -1 &&
                            <Field name="consumer_usual_products_other" component={renderTextField} label='Especifique cuál' />
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Utiliza productos para depilarse?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'use_hair_removal_products',
                                options: this.props.common.yesno || [],
                            })}
                        </Grid>
                        {
                            formValues.use_hair_removal_products == "2" &&
                            <React.Fragment>
                                <Grid item xs={12}>
                                    <Typography variant="subheading" style={{ marginTop: 15 }}>
                                        ¿Dónde? (zona)
                                        </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {renderGenericCheckboxGroup({
                                        name: 'hair_removal_zones',
                                        options: this.props.common.hair_removal_zones || [],
                                        fullWidth: true
                                    })}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subheading" style={{ marginTop: 15 }}>
                                        ¿Qué producto?
                                        </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {renderGenericCheckboxGroup({
                                        name: 'hair_removal_products_list',
                                        options: this.props.common.hair_removal_products_list || [],
                                        fullWidth: true
                                    })}
                                </Grid>
                            </React.Fragment>
                        }
                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Se hace o se ha hecho la depilación láser?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'had_laser_hair_removal',
                                options: this.props.common.yesno || [],
                            })}
                            {
                                formValues.had_laser_hair_removal == "2" && renderGenericTextField('Especifique en qué zona(s)', 'had_laser_hair_removal_user_input')
                            }
                        </Grid>


                        <Grid item xs={12}>
                            <Typography variant="subheading" style={{ marginTop: 15 }}>
                                ¿Tienes tatuajes?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            {renderOptionsField({
                                name: 'has_tattoos',
                                options: this.props.common.yesno || [],
                            })}
                            {
                                formValues.has_tattoos == "2" && renderGenericTextField('Qué zona(s)', 'has_tattoos_value')
                            }
                        </Grid>
                        <Grid container spacing={8} style={{ marginTop: '10%' }}>
                            <Grid item xs={12} align="center">
                                <Snackbar
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left"
                                    }}
                                    open={this.state.open}
                                    autoHideDuration={3000}
                                    onClose={this.handleClose}
                                >
                                    <MySnackbarContentWrapper
                                        onClose={this.handleClose}
                                        variant="success"
                                        message="This is a success message!"
                                    />
                                </Snackbar>
                                <Button type="submit" variant="contained" color="primary" disabled={pristine || submitting}>
                                    Save
                            </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Nombre *</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.first_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Primer apellido *</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.last_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Segundo apellido</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.user.second_last_name}</span>
                        </div>
                    </div>
                    <hr />
                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Elija los tipos de test que prefiera realizar:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.preferred_test_types}
                            data={accData.test_type}
                        />
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Elija la zona del cuerpo donde prefiera realizar estudios:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.preferred_application_zones}
                            data={accData.test_application_zone}
                        />
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Vía de contacto para la invitación a los estudios:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.contact_method}
                            data={accData.contact_method}
                        />
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>Disponibilidad horaria de asistencia a los estudios (marcar todas las que pueda):</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.contact_time}
                            data={accData.contact_time}
                        />
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Tienes hijos menores de edad?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_children ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Te interesa que tus hijos menores de edad participen en los estudios:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.accept_children_to_test ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>

                <Grid item xs={12}>
                    <label className='form__form-group-label'> ¿Presenta o ha presentado alguna vez algún tipo de enfermedad de las que se exponen a continuación:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.disease_type}
                            data={accData.disease_type}
                        />
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Está realizando o ha realizado alguna vez algún tratamiento inmunosupresor:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.immunosuppressive_treatment ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Está realizando o ha realizado algún otro tratamiento médico en los últimos 6 meses:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.other_treatment ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.other_treatment === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿De qué tipo? Especifique la duración aproximada del tratamiento:</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.other_treatment_description}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Toma de forma recurrente algún medicamento de la siguiente lista:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.legal_drug}
                            data={accData.legal_drug}
                        />
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Le han realizado alguna vez un trasplante de órgano o una ablación de órgano:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.organ_transplant ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {/* <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Le han realizado alguna intervención quirúrgica recientemente o en el último año:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.had_surgery ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.had_surgery === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿De qué tipo y cuándo:</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.had_surgery_description}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                } */}
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez un traumatismo craneal con pérdida de conocimiento prolongada:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.cranial_trauma ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Para las voluntarias de sexo femenino, ¿Utiliza medios de contracepción eficaz:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.contraception ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Presenta algún tipo de las afecciones cutáneas descritas a continuación? (Marque tantas como sea necesario):</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.skin_affections}
                            data={accData.skin_affection}
                        />
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Presenta alguna alergia documentada:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.has_allergies ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.has_allergies === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿A qué?:</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.has_allergies_user_input}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿En su familia hay personas que padezcan enfermedades alérgicas?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.family_has_allergies ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.family_has_allergies === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿Quién? :</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.family_has_allergies_user_input}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez reacciones importantes a picaduras de insectos?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.reactions_to_insect_bites ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez reacciones importantes y/o alérgicas al sol (picazón, urticaria, granitos...)?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.reactions_to_sun ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez reacciones alérgicas a algún alimento?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.food_allergies ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.food_allergies === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿A qué alimento(s)? :</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.food_allergies_user_input}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez reacciones alérgicas a algún medicamento?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.drug_allergies ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.drug_allergies === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿A qué medicamento(s)? :</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.drug_allergies_user_input}</span>
                            </div>

                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha tenido alguna vez reacciones alérgicas a algún producto cosmético?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.cosmetic_product_allergies ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.cosmetic_product_allergies === true &&
                    <div>
                        <Grid item xs={12}>
                            <label className='form__form-group-label'>¿A qué producto(s) cosmético(s)? :</label>
                            <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                                <span>{accData.cosmetic_product_allergies_description_product}</span>
                                </div>
                            </div>
                        </Grid>
                        <hr />

                        <Grid item xs={12}>
                            <label className='form__form-group-label'>¿En qué zona del cuerpo tuvo la reacción? :</label>
                            <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                                <span>{accData.cosmetic_product_allergies_description_body_zone}</span>
                                </div>
                            </div>
                        </Grid>
                        <hr />

                    </div>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Es usted una persona sujeta a tener...?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.possible_affections}
                            data={accData.possible_affections}
                        />
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Ha presentado alguna vez reacciones alérgicas o reacciones adversas a alguno de los siguientes productos?:</label>
                    <div className='form__form-group-field'>
                        <CheckBoxCustomHelper
                            options={common.allergies_product_list}
                            data={accData.allergic_reactions_to}
                        />
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Sexo :</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.gender}</span>
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>Height :</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            <span>{accData.height}</span>
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Es fumador/a?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.is_smoking ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                {accData.is_smoking === true &&
                    <Grid item xs={12}>
                        <label className='form__form-group-label'>¿Cuántos cigarros fuma al día? :</label>
                        <div className='form__form-group-field'>
                        <div className='checkbox-value'>

                            <span>{accData.smoking_user_input}</span>
                            </div>
                        </div>
                        <hr />

                    </Grid>
                }
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Está apuntado/a en otro centro donde realicen pruebas con productos cosméticos?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.enrolled_in_other_center ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                <Grid item xs={12}>
                    <label className='form__form-group-label'>¿Está afiliado al régimen de seguridad social o seguro de salud?:</label>
                    <div className='form__form-group-field'>
                        <div className='checkbox-value'>
                            {accData.social_security_affiliation ? <span>Sí</span> : <span>No</span>}
                        </div>
                    </div>
                    <hr />

                </Grid>
                
            </React.Fragment >
        )
    }
}

VolontarioForm = reduxForm({
    form: 'volontarioForm',
    persistentSubmitErrors: false,
    // validate
})(VolontarioForm)
VolontarioForm = connect(state => ({
    account: state.account,
    auth: state.auth,
    common: state.common,
    formValues: getFormValues('volontarioForm')(state)
}))(VolontarioForm);
export default VolontarioForm;



// WEBPACK FOOTER //
// ./src/modules/account/forms/VolontarioForm.js